import { useCurrentUserTags } from 'hooks/useCurrentUserTags';
import useProjectRoute from 'hooks/useProjectRoute';

const useTemplateEngineUser = () => {
  const { accountId } = useProjectRoute();

  const userTags = useCurrentUserTags({ accountId, isEnabled: true });
  const isTemplateEngineUser =
    userTags?.some(t => t === 'template-engine') ?? false;

  return {
    isTemplateEngineUser,
  };
};

export default useTemplateEngineUser;
